module.exports = {
  createGoal: function (payload) {
    return this.client.post(`/v${this.v}/user_goal/`, payload)
  },
  getUserGoals: function (params) {
    return this.client.get(`/v${this.v}/user_goal/`, {
      params: params,
    })
  },
  getGoalProgress: function (params) {
    return this.client.get(`/v${this.v}/user_goal_progress/`, {
      params: params,
    })
  },
  stopUserGoal: function (goalId) {
    return this.client.patch(`/v${this.v}/user_goal/${goalId}/`, {
      status: 'abandoned',
      end_datetime: (new Date()).toISOString(),
    })
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/goals.js